export enum Hierarchy {
  ORGANIZATIONAL_ADMIN = "organizational_admin",
  HEAD = "head",
  TEAM_LEAD = "team_lead",
  MEMBER = "member",
}